import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { GB_PRIVACY_STATEMENT_URL } from '../../config/GBConstants';

const LOCALE_PREFIX = 'GB/components/Footer/FooterLinks';

export class FooterLinks extends Component {
    static propTypes = {
        showFeedbackLink: PropTypes.bool,

        // Passed in props
        showLinks: PropTypes.bool
    };

    static defaultProps = {
        showFeedbackLink: false,
        showLinks: true
    };

    handleClickFeedback = event => {
        event.preventDefault();
        window.launchOpinionLabStandardFeedback(event);
    };

    render() {
        const { showFeedbackLink, showLinks } = this.props;
        const year = new Date().getFullYear();

        return (
            <div className="footerLinks-gb">

                {showLinks && [(
                    <a
                        href="https://www.paypal.com/uk/webapps/mpp/ua/legalhub-full"
                        data-automation-id="legal-link"
                        className="cue-footer-link"
                        target="_blank"
                        key="legal"
                    >
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.legal`}
                        />
                    </a>
                ), (
                    <a
                        href={GB_PRIVACY_STATEMENT_URL}
                        data-automation-id="privacy-link"
                        className="cue-footer-link"
                        target="_blank"
                        key="privacy"
                    >
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.privacy`}
                        />
                    </a>
                )]}

                {showFeedbackLink && (
                    <a
                        href="#"
                        data-automation-id="feedback"
                        className="cue-footer-link oo-feedback"
                        name="PayPalFeedback-Footer"
                        onClick={this.handleClickFeedback}
                    >
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.feedback`}
                        />
                    </a>
                )}

                <div className="security-footer">
                    <span className="cue-footer-link">© 1999-{year}</span>
                    <div id="cue-security-icon" />
                </div>
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    showFeedbackLink: _.get(state, 'serverData.featureFlags.wireOnFeedback')
});

export default connect(mapStateToProps)(FooterLinks);
